import {ErrorHandler, Injectable, Injector, NgZone} from "@angular/core";
import {NotificationService} from "../root/toast/notification.service";
import {ErrorLogService} from "./error-log.service";
import {Location} from "@angular/common";
import {WindowRef} from "./window-ref";
import {LoadingWheelService} from "../root/loading/loading-wheel.service";
import {Router} from "@angular/router";

@Injectable()
export class AngularErrorHandler extends ErrorHandler {

    private options: any = {rethrowError: false};
    private navigator:Router;
    constructor(private errorLogService: ErrorLogService, private notifications:NotificationService,
                private  zone: NgZone, private _window:WindowRef, private loading:LoadingWheelService,
                private injector: Injector) {
        super();
        this.navigator = this.injector.get(Router);
    }

    public handleError( error: any ) : void {
        this.reportError(error);
        this.handleStatus(error);
        if ( this.options.rethrowError ) {
            throw( error );
        }
    }

    private reportError(error: any){

        try {
            this.errorLogService.logError( error );
        } catch ( loggingError ) {
            console.group( "ErrorHandler" );
            console.warn( "Error when trying to log error to", this.errorLogService );
            console.log( loggingError );
            console.groupEnd();
        }
    }

    private handleStatus(error: any) {
        var data;
        var context = this;
        this.zone.run(() => {
            if(!!error && !!error._body){
                try {
                    data = JSON.parse(error._body);
                } catch (e) {
                    data = error._body;
                }
            }
            switch(error.status) {
                case 400:
                    if (!data) {
                        this.notifications.notifyFrontErrorDetailByCodes(error);
                    } else {
                        if (!data.params) {
                            this.notifications.notifyFrontErrorDetailByCodes(data);
                        } else {
                            this.notifications.notifyErrorByCodeWithParams(data.message, data.params);
                        }
                    }
                    break;
                case 401:
                    if (!!data.message && data.message != 'CREDENTIALS_EXPIRED') {
                        this._window.goHref('login');
                    }
                    break;
                case 403:
                    this._window.goHref('error');
                    break;
                case 404:
                    this._window.goHref('resourceNotFound');
                    break;
                case 500:
                    this.navigator.navigateByUrl('/internal-error')
                    // this._window.goHref('internal-error');
                    break;
                default:
                    this.notifications.notifyErrorByCode("common.ERROR_500");
            }
            context.loading.hide();
        });
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/angular-error-handler.ts